import { defineMessages } from 'react-intl';

const messages = defineMessages({
  title: {
    id: 'App.ErrorBoundary.Title',
    defaultMessage: 'Unexpected Fortress Error',
  },
  confirmMessage: {
    id: 'App.ErrorBoundary.ConfirmMessage',
    defaultMessage:
      'Something went wrong while loading this page. Please try refreshing. ' +
      'If the issue continues, contact support so we can take a closer look.',
  },
  devConfirmMessage: {
    id: 'App.ErrorBoundary.DevConfirmMessage',
    defaultMessage: 'Please contact your system administrator: {error}',
  },
  submit: {
    id: 'App.ErrorBoundary.Submit',
    defaultMessage: 'OK',
  },
  socketSessionError: {
    id: 'App.ErrorBoundary.SocketSessionError',
    defaultMessage:
      // eslint-disable-next-line max-len
      "Your session timed out or couldn't be restored. Please log in again. If the issue continues, try clearing site data or contact support.",
  },
});

export default messages;
